/** Matches the apiserver/nginx request body limit of 50 MiB. */
export const MAX_PUBLIC_UPLOAD_FILE_SIZE_BYTES = 50 * 1024 * 1024

/** Derived from the byte limit so the two can never drift apart. */
export const MAX_PUBLIC_UPLOAD_FILE_SIZE_MB = MAX_PUBLIC_UPLOAD_FILE_SIZE_BYTES / (1024 * 1024)

/**
 * Splits files into those within the public upload size limit and those that exceed it.
 * Files at or above the limit are rejected because multipart overhead would push the
 * request body over the backend's hard 50 MiB cap.
 */
export const partitionFilesByMaxSize = (files: File[], maxBytes = MAX_PUBLIC_UPLOAD_FILE_SIZE_BYTES) => {
  const accepted: File[] = []
  const rejected: File[] = []

  for (const file of files) {
    if (file.size >= maxBytes) {
      rejected.push(file)
    } else {
      accepted.push(file)
    }
  }

  return { accepted, rejected }
}
